import React from 'react';
import { Container, Grow, Grid, Typography, Button } from '@material-ui/core';
// import { Pagination, PaginationItem } from '@material-ui/lab'
// import { getPostsBySearch } from '../../actions/posts';
// import { useDispatch } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
// import ChipInput from 'material-ui-chip-input';

// import Posts from '../Posts/Posts';
// import Form from '../Form/Form';
import SliderTab from './SliderTab/SliderTab';
// import Footer from '../Footer/Footer';
import useStyles from './styles';
import illustration from '../../assets/others/flare_illustration.png';
import AGB_img from '../../assets/support company/AGB.png';
import ICHIGO_img from '../../assets/support company/ICHIGO.png';
import LEAVEANET_img from '../../assets/support company/leave_a_nest.png';
import Patagonia_img from '../../assets/support company/Patagonia.png';
import KYOTANGO_img from '../../assets/support company/kyotango.png';
import OIOI_img from '../../assets/support company/oioiNoBG.png';
import Seames_img from '../../assets/support company/seamesNoBG.png';
import Qulii_img from '../../assets/support company/quliiNoBG.png';
import ADVISOR1_img from '../../assets/advisors/advisor1.jpeg';
import ADVISOR_COMING_SOON_img from '../../assets/advisors/coming_soon.png';
import question_icon from '../../assets/logo/question_icon.png';
import useCommonStyles from '../CommonStyle/commonStyle';
import PopModal from '../PopModal/PopModal';
import GoToTop from '../Functional/GoToTop';

// function useQuery() {
//     return new URLSearchParams(useLocation().search);
// }

const Landing = () => {

    const classes = useStyles();
    const commonClasses = useCommonStyles();
    // const released = true;

    const [open, setOpen] = React.useState(false);
    const handleOpen = () => {
        setOpen(true);
    };
    // const handleClose = () => {
    //     setOpen(false);
    // };
    console.log("checking released boolean");
    console.log(typeof process.env.REACT_APP_STAGE);


    return (
        <Grow in>
            <Container maxWidth="lg" className={commonClasses.bodyContainer}>
                <Grid container direction="row" justifyContent="space-between" alignItems="stretch" spacing={3} className={classes.topGridContainer}>
                    <Grid item xs={12} sm={6} md={6} className={classes.leftGrid}>
                        <Typography component={'span'} variant="h2" className={classes.motivationalTitle} >
                            世界を<br />変えよう<br />みんなの力で<br />
                        </Typography>
                        <Typography component={'span'} variant="h6" className={classes.smallTitle}>
                            <br /> <br /> 社会問題を解決したい未成年が、 <br />共創したい企業と出会えるプラットフォーム。
                        </Typography >

                        <br />
                        {
                            process.env.REACT_APP_STAGE !== 'prod' ? (
                                <>
                                    <Button component={Link} to="/startup/signup" className={classes.signupButton}>新規登録</Button>
                                    <Button component={Link} to="/startup/login" className={classes.loginButton}>ログイン</Button>
                                </>
                            ) : (
                                <>
                                    <Button component={Link} to="#" className={classes.signupButton} onClick={handleOpen}>新規登録</Button>
                                    <Button component={Link} to="#" className={classes.loginButton} onClick={handleOpen}>ログイン</Button>
                                    <PopModal setOpen={setOpen} open={open} />
                                </>)
                        }
                    </Grid>
                    <Grid container item xs={12} sm={6} md={6}>
                        <img src={illustration} width="600"></img>
                    </Grid>

                </Grid>
                <div className={classes.sliderTab}>
                    <SliderTab />
                </div>
                <Typography component={'span'} variant="h5" className={commonClasses.sectionOrangeTitle} >
                    Q&A<br />
                </Typography>
                <Grid xs={12} sm={12} md={12} className={commonClasses.QA}>
                    <QA question='まだ社会問題や環境問題解決のためにアクションを起こせていないのですが参加できますか？' answer='はい！参加可能です。Flareのコミュニティでは多種多様なイベントやプログラムを準備しています。Flareはあなたのアクションの一歩目を丁寧にサポートします。※プロジェクト内容や取り組み内容によって事前の相談と確認があります' />
                    <QA question='企業からはどのようにアプローチがあるのですか？' answer='あなたのプロジェクトと共創したいと思った企業から共創申請(メッセージ)が届きます。あなたがその共創申請を承諾すると共創に向けた対話の機会が設定され、様々なサポートが受けられます。' />

                </Grid>
                <Typography component={'span'} variant="h5" className={commonClasses.sectionOrangeTitle} >
                    Advisors<br />
                </Typography>
                <Grid container direction="row" justifyContent="space-evenly" alignItems="center" spacing={0} className={classes.advisorsGrid}>
                    <Grid container item justifyContent="space-evenly" alignItems="center">
                        <Grid item xs={12} sm={6} md={4} className={classes.advisorParent} >
                            <img className={classes.advisorImg} src={ADVISOR1_img} />
                            <Typography className={classes.advisorName}>
                                板崎 一雄
                            </Typography>
                            <Typography className={classes.advisorBody}>
                                弁護士。大手法律事務所でM&A、独占禁止法などの企業法務、行政機関を経て、近年、社会貢献・SDG関連を含めて、起業、ベンチャー・スタートアップ企業の支援に力を入れている。会社役員も兼任。
                            </Typography>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} className={classes.advisorParent} >
                            <img className={classes.advisorImg} src={ADVISOR_COMING_SOON_img} />
                            <Typography className={classes.advisorName}>
                                Coming Soon...
                            </Typography>
                            <Typography className={classes.advisorBody}>

                            </Typography>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} className={classes.advisorParent} >
                            <img className={classes.advisorImg} src={ADVISOR_COMING_SOON_img} />
                            <Typography className={classes.advisorName}>
                                Coming Soon...
                            </Typography>
                            <Typography className={classes.advisorBody}>

                            </Typography>
                        </Grid>
                    </Grid>

                </Grid>
                <Typography component={'span'} variant="h5" className={commonClasses.sectionOrangeTitle} >
                    Flare Partner<br />
                </Typography>
                <Grid container direction="row" justifyContent="space-evenly" spacing={1} className={classes.sponsorDiv}>
                    {/* <Grid item>
                        <img className={classes.sponsorLogos} src={AGB_img} />
                    </Grid> */}
                    <Grid item>
                        <img className={classes.sponsorLogos} src={ICHIGO_img} alt="Ichigo" />
                    </Grid>
                    <Grid item>
                        <img className={classes.sponsorLogos} src={LEAVEANET_img} alt="Leaveanet"/>
                    </Grid>
                    <Grid item>
                        <img className={classes.sponsorLogos} src={Patagonia_img} alt="Patagonia"/>
                    </Grid>
                    <Grid item>
                        <img className={classes.sponsorLogos} src={KYOTANGO_img} alt="Kyotango"/>
                    </Grid>
                    <Grid item>
                        <img className={classes.sponsorLogos} src={OIOI_img} alt="Oioi"/>
                    </Grid>
                    <Grid item>
                        <img className={classes.sponsorLogos} src={Seames_img} alt="Seames"/>
                    </Grid>
                    <Grid item>
                        <img className={classes.sponsorLogos} src={Qulii_img} alt="Qulii"/>
                    </Grid>
                </Grid>


                {/* </div> */}
                <GoToTop />
            </Container>
            {/* <Footer /> */}
        </Grow>
    )
    function QA(props: { question: string; answer: string; }) {
        return <><div className={commonClasses.questionDiv}>
            <img src={question_icon} alt="question_icon" className={commonClasses.questionIcon} />
            <Typography className={commonClasses.questionText}>
                {props.question}
            </Typography>
        </div><div className={commonClasses.answerDiv}>
                <Typography className={commonClasses.answerIcon}>
                    A.
                </Typography>
                <Typography>
                    {props.answer}
                </Typography>
            </div></>;
    }
};

export default Landing;
